import PripomienkaDetailPage from './PripomienkaDetailPage';

export default PripomienkaDetailPage;
